module.exports = __webpack_public_path__ + "media/jobs_page/heroimg_countryjobs_mobile-5a9a0b3b.jpg";